export default "__VITE_PUBLIC_ASSET__6c829b34__"